export const MACHINERY_CATEGORY_TAGS = {
    CATEGORY_LIST: "getCategoryList",
    CATEGORY_BY_ID: "getCategoryById",
} as const;